import React from 'react'
import { useState } from 'react';
import { Container, Card, Form, Button } from 'react-bootstrap';
import axios from 'axios';

function Login({ setIsLogin }) {
    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [showSubscribeScreen, setShowSubscribeScreen] = useState(false);

    const USERNAME = "admin"
    const PASSWORD = "vy0s!m2026"

    const handleLogin = (username, password) => {
        if (!username || !password) {
            setMessage('Username and password are required');
            return false;
        }
        if ((username === USERNAME) && (password === PASSWORD)) {
            setMessage('Login successful');
            setIsLogin(true);
            return true;
        }
        else {
            setMessage('Invalid username or password');
            return false;
        }
    }

    const Subscribe = () => {
        const [subscriber, setSubscriber] = useState({ name: '', email: '', phone: '' });
        const [subscribeMessage, setSubscribeMessage] = useState('');
        const [isSubscribe, setIsSubscribe] = useState(false);

        const handleSubscribe = async () => {
            if (!subscriber.name || !subscriber.email || !subscriber.phone) {
                setSubscribeMessage('All fields are required');
                return;
            }
            try {
                const response = await axios.post('/subscribe', subscriber);
                setIsSubscribe(true);
                console.log(response.data);
            }
            catch (error) {
                console.error(error);
            }
        }
        return (
            <>
                {isSubscribe ? (
                    <div className="text-center">
                        <h4 className="mb-3 fw-bold">Thank You for Subscribing!</h4>
                        <p>Hi {subscriber.name},</p>
                        <p>We’ve received your details successfully.</p>
                        <p>Our team will review your request and get back to you soon.</p>
                        <p>Please check your email for further updates.</p>
                        <Button variant="secondary" className="text-decoration-none font-bold w-1/2" onClick={() => setShowSubscribeScreen(false)}>Back to Login</Button>
                    </div>
                ) : (
                    <Form className="text-start">
                        <Form.Group controlId="username" className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter name" value={subscriber.name} onChange={(e) => setSubscriber({ ...subscriber, name: e.target.value })} required />
                        </Form.Group>

                        <Form.Group controlId="Email" className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="email" value={subscriber.email} onChange={(e) => setSubscriber({ ...subscriber, email: e.target.value })} required />
                        </Form.Group>

                        <Form.Group controlId="Phone" className="mb-3">
                            <Form.Label>Phone</Form.Label>
                            <Form.Control type="phone" placeholder="phone" value={subscriber.phone} onChange={(e) => setSubscriber({ ...subscriber, phone: e.target.value })} required />
                        </Form.Group>

                        {subscribeMessage && <div className="alert alert-danger my-2 py-1">{subscribeMessage}</div>}
                        <div className="d-flex justify-content-center gap-2">
                            <Button variant="secondary" className="text-decoration-none font-bold px-2" onClick={() => setShowSubscribeScreen(false)}> Back to Login </Button>
                            <Button className="btn-custom border-0 px-4" onClick={handleSubscribe}> Subscribe </Button>
                        </div>
                    </Form>
                )}
            </>
        )
    }


    return (
        <Container fluid className="vh-100 d-flex justify-content-center align-items-center glass-background">
            <Card className="login-card p-4 border-0" style={{ width: '400px', maxWidth: '90%' }}>
                <div className="text-center mb-4">
                    <h3 className="fw-bold" style={{ color: '#5f0082ff' }}>{showSubscribeScreen ? "Subscribe" : "Login"}</h3>
                </div>
                {showSubscribeScreen ? <Subscribe /> : (
                    <Form className="text-start">
                        <Form.Group controlId="username" className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control type="text" placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} required />
                        </Form.Group>

                        <Form.Group controlId="password" className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </Form.Group>

                        {message && <div className="alert alert-danger py-2">{message}</div>}
                        <div className="text-center">
                            <Button className="btn-custom border-0 w-1/3 px-4 " size="" onClick={() => handleLogin(username, password)}>
                                Login
                            </Button>
                        </div>
                        <div className="text-center mt-2">
                           <span className="text-muted">New user? </span>
                            <Button variant="link" className="p-0 text-decoration-none fw-bol" style={{ color: '#5f0082ff' }} onClick={() => setShowSubscribeScreen(true)}>
                                Subscribe here
                            </Button>
                        </div>
                    </Form>
                )}
            </Card>
        </Container>
    )
}
export default Login;